export enum PanoramaTransaction {
    QueryLibraryItems = 'queryLibraryItems',
    AuthorizeActions = 'authorizeActions'
}